//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  emits: [
    'resetSearch',
    'searchQuestions'
  ],
  props: {
    tags: {
      type: Array,
      required: false
    },
    idChoosingTagFromQuestion: {
      type: Number,
      required: false,
    }
  },
  data() {
    return {
      searchBody: {
        search_phrase: "",
        specialist: "",
        tags: "",
        limit: "",
        page: "",
      },
      accumTags: [],
      questionsFromSearchResponse: [],
    }
  },
  computed: {
  },
  methods: {
    chooseTag(id) {
      let _accum = this.accumTags || []

      if (_accum.includes(id)){
       _accum = _accum.filter((item) => item !== id)
      } else {
        _accum.push(id)
      }

      this.accumTags = _accum

      this.searchQuestions();
    },
    searchQuestions() {
      this.$emit('searchQuestions', this.searchBody, this.accumTags)
    },
    resetSearch() {
      const resetSearchBody = {
        search_phrase: "",
        specialist: "",
        tags: "",
        limit: "",
        page: "",
      };
      const resetAccumTags = []

      this.searchBody = resetSearchBody;
      this.accumTags = resetAccumTags;
      this.$emit('resetSearch')
    }
  }
}
